module.exports = __webpack_public_path__ + "img/r7.c45dea4e.png";